import React, { useContext } from 'react'

import PersonnalInformationsForm from './PersonnalInformationsForm'
import PhoneNumberForm from './PhoneNumberForm'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons'
import { Card, Tooltip } from 'antd'
import { mapStateToProps, mapDispatchToProps, connect } from '../../../reducers/Dispatchers'
import { StudentContext } from '../../../Providers/Student/StudentProvider'
import { updateStudent } from '../../../utils/api/student'
import { onError, onSuccess } from '../../../utils/apiHelper'

import '../../../assets/profile-page.scss'

const ACADEMIC_DATA_TITLE = 'My school contact information'
const PRIVATE_DATA_TITLE = 'My personal contact information'
const TIPS_TEXT = 'Information necessary for the preparation of your internship and contact in case of problems.\n' +
  'Possibility of contact for recruitment purposes if desired.'

const PersonnalInformations = (props) => {
  const { schools, student, setStudent } = useContext(StudentContext)

  const renderSchoolAddress = () => {
    return schools.map(school => {
      const address = [
        school.address,
        school.city,
        school.zipcode,
        school.country ? school.country.code : null
      ].filter(item => item).join(', ')

      return <div key={school.id}>{address}</div>
    })
  }

  /**
   * Save the school phone number of the student and reflect it in the student context
   *
   * @param {string} phoneNumber the new school phone number
   */
  const handlePhoneNumberUpdate = async phoneNumber => {
    if (!student) {
      return
    }

    try {
      const json = await updateStudent(props.getUser, student, { phoneNumber })

      if (json?.data) {
        setStudent({ ...student, phoneNumber })
        onSuccess(props.t('Saved changes'))

        return
      }

      onError(props.t('Error saving'))
    } catch (error) {
      onError(props.t('Error saving'))
    }
  }

  /**
   * Render the content of the section with the informations linked to the student school
   *
   * @returns React grape of the school section
   */
  const renderSchoolInformation = () => {
    return (
      <div>
        <div className='inner-margin'>
          <Card
            type='inner'
            title={[<FontAwesomeIcon key={0} icon='school' />, ' ', props.t('Address')]}
          >
            {renderSchoolAddress()}
          </Card>
        </div>
        <div className='inner-margin'>
          <Card
            type='inner'
            title={[<FontAwesomeIcon key={1} icon='at' />, ' ', props.t('Email')]}
          >
            {props.getUser?.email ?? ''}
          </Card>
        </div>
        <PhoneNumberForm
          phoneNumber={student?.phoneNumber ?? ''}
          onSubmit={handlePhoneNumberUpdate}
        />
      </div>
    )
  }

  return (
    <div className='profile-page-personnal'>
      <div className='profile-page-card-div'>
        <Card
          title={props.t(ACADEMIC_DATA_TITLE)}
        >
          {renderSchoolInformation()}
        </Card>
      </div>

      <div className='profile-page-card-div'>
        <Card
          title={[props.t(PRIVATE_DATA_TITLE), ' ',
            <Tooltip key='personal_section_tooltip' placement='right' title={props.t(TIPS_TEXT)}>
              <FontAwesomeIcon icon={faQuestionCircle} color='#1890ff' />
            </Tooltip>
          ]}
        >
          <PersonnalInformationsForm />
        </Card>
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonnalInformations)
